import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {PrismicRichText} from '@prismicio/react'
import Script from 'next/script'
import type {FC} from 'react'
import {Container} from 'src/common/Container'

/**
 * Props for `AshbyContainer`.
 */
export type AshbyContainerProps = SliceComponentProps<Content.AshbyContainerSlice>

/**
 * Component for "AshbyContainer" Slices.
 */
const AshbyContainer: FC<AshbyContainerProps> = ({slice}) => (
  <Container
    className="gap-6 px-5 md:gap-12 md:px-10 lg:px-5 xl:px-0"
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
  >
    <div
      className="mx-auto flex w-full max-w-[1200px] flex-col gap-6 md:gap-12"
      data-aos="fade-up"
      data-aos-offset="0"
      id="open-roles"
    >
      <div className="flex flex-col gap-6">
        <span className="text-button-s text-moss-blue">{slice.primary.tag}</span>
        <div>
          <PrismicRichText
            field={slice.primary.heading}
            components={{
              heading2: ({children}) => (
                <h2 className="md:text-tg-h2 text-32 font-normal leading-[normal] tracking-[-.32px] text-moss-black">
                  {children}
                </h2>
              ),
              strong: ({children}) => <p className="font-normal text-moss-grey-400">{children}</p>,
            }}
          />
        </div>
      </div>
      <div id="ashby_embed" />
    </div>
    <Script strategy="afterInteractive" src="https://jobs.ashbyhq.com/moss/embed" />
  </Container>
)

export default AshbyContainer
